import OpenSavingsAccount from 'features/accounts/savings/OpenSavingsAccount/OpenSavingsAccount';
import React from 'react';

export default function Page() {
  return <OpenSavingsAccount />;
}
